module.exports = __webpack_public_path__ + "img/Picture10.3e8008b3.jpg";